<template>
  <v-dialog
    v-model="visible"
    persistent
    style="position: absolute; z-index: 7"
    :width="opts.width"
    :max-width="opts.maxWidth"
    :min-height="opts.minHeight"
    retain-focus
  >
    <v-card class="msgbox-card">
      <div :class="['msgbox-title', opts.color === 'error' ? 'msgbox-title-error' : opts.color === 'info' ? 'msgbox-title-info' : 'msgbox-title-warning']">
        <v-icon left color="white" size="28">
          {{ opts.color === 'error' ? 'mdi-alert-circle' : opts.color === 'info' ? 'mdi-information' : 'mdi-alert' }}
        </v-icon>
        <span class="msgbox-title-text" v-if="opts.title">{{ opts.title }}</span>
        <span class="msgbox-title-text" v-else>{{ opts.color === 'error' ? 'Greška' : opts.color === 'info' ? 'Informacija' : 'Upozorenje' }}</span>
      </div>

      <v-card-subtitle v-if="opts.subtitle" class="msgbox-subtitle">
        {{ opts.subtitle }}
      </v-card-subtitle>

      <v-card-text class="msgbox-text">
        {{ opts.text ? opts.text : "" }}

        <slot></slot>
      </v-card-text>

      <v-card-actions class="msgbox-actions pr-5 pb-5 pl-5">
        <v-spacer />
        <v-btn
          v-if="opts.actions && opts.actions.includes('cancel')"
          @click="onCancelClick"
          class="msgbox-cancel-btn"
          elevation="0"
        >
          <v-icon left small>mdi-close</v-icon>
          {{ opts.cancelBtnText }}
        </v-btn>
        <v-btn
          v-if="opts.actions && opts.actions.includes('ok')"
          @click="onOkClick"
          id="success"
          class="msgbox-ok-btn ml-2"
          :loading="loading"
          elevation="0"
        >
          <v-icon left small>mdi-check</v-icon>
          {{ opts.okBtnText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const defaults = {
  title: undefined,
  type: 'notification',
  icon: 'mdi-notification',
  text: undefined,
  actions: ['ok'],
  okBtnText: 'Ok',
  submitting: false,
  cancelBtnText: 'Cancel',
  color: 'info',
  okBtnColor: 'okButton',
  cancelBtnColor: 'okButton',
  subtitle: '',
  width: '450',
  minHeight: '125',
  maxWidth: '1000'
}
export default {
  name: 'MsgBox',
  data: () => ({
    opts: {},
    visible: false
  }),
  props: ['loading', 'preventClose', 'toolbar'],
  methods: {
    show (config = {}) {
      this.opts = { ...defaults, ...config }
      this.visible = true
      this.$emit('show')
    },
    hide () {
      this.visible = false
    },
    onOkClick () {
      this.opts = {}
      this.$emit('ok')
      this.visible = false
    },
    onCancelClick () {
      this.opts = {}
      this.visible = false
      this.$emit('cancel')
    }
  }
}
</script>
<style scoped>
/* MsgBox Card */
.msgbox-card {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  -webkit-backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.12) !important;
}

/* MsgBox Title - Error */
.msgbox-title-error {
  background: linear-gradient(135deg,
    rgba(244, 67, 54, 0.5) 0%,
    rgba(229, 57, 53, 0.45) 50%,
    rgba(211, 47, 47, 0.5) 100%) !important;
}

/* MsgBox Title - Info */
.msgbox-title-info {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.5) 0%,
    rgba(57, 137, 201, 0.45) 50%,
    rgba(97, 84, 164, 0.5) 100%) !important;
}

/* MsgBox Title - Warning */
.msgbox-title-warning {
  background: linear-gradient(135deg,
    rgba(255, 152, 0, 0.5) 0%,
    rgba(251, 140, 0, 0.45) 50%,
    rgba(245, 124, 0, 0.5) 100%) !important;
}

/* MsgBox Title Base */
.msgbox-title {
  padding: 20px 24px !important;
  display: flex !important;
  align-items: center !important;
  position: relative;
}

.msgbox-title::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  opacity: 0.3;
  pointer-events: none;
}

.msgbox-title-text {
  color: white !important;
  font-weight: 700 !important;
  font-size: 18px !important;
  letter-spacing: 0.5px !important;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 1;
}

/* MsgBox Subtitle */
.msgbox-subtitle {
  padding: 16px 24px 8px 24px !important;
  color: rgba(0, 0, 0, 0.6) !important;
  font-size: 14px !important;
}

/* MsgBox Text */
.msgbox-text {
  padding: 16px 24px !important;
  font-weight: 500 !important;
  color: rgba(0, 0, 0, 0.87) !important;
  font-size: 15px !important;
  line-height: 1.6 !important;
}

/* MsgBox Actions */
.msgbox-actions {
  padding: 16px 24px 24px 24px !important;
}

/* MsgBox OK Button - Soft Success Style */
.msgbox-ok-btn {
  background: rgba(255, 255, 255, 0.8) !important;
  color: #4CAF50 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(76, 175, 80, 0.15) !important;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 0 24px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.msgbox-ok-btn:hover:not(:disabled) {
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.25) !important;
  border-color: rgba(76, 175, 80, 0.3) !important;
  transform: translateY(-1px);
}

.msgbox-ok-btn .v-icon {
  color: #4CAF50 !important;
  font-size: 18px !important;
}

/* MsgBox Cancel Button - Soft Danger Style */
.msgbox-cancel-btn {
  background: rgba(255, 255, 255, 0.8) !important;
  color: #F44336 !important;
  border-radius: 12px !important;
  border: 1px solid rgba(244, 67, 54, 0.15) !important;
  box-shadow: 0 2px 8px rgba(244, 67, 54, 0.15) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  letter-spacing: 0.3px !important;
  padding: 0 18px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.msgbox-cancel-btn:hover {
  box-shadow: 0 4px 12px rgba(244, 67, 54, 0.25) !important;
  border-color: rgba(244, 67, 54, 0.3) !important;
  transform: translateY(-1px);
}

.msgbox-cancel-btn .v-icon {
  color: #F44336 !important;
  font-size: 18px !important;
}
</style>
